import React from 'react';
import { Paper, Typography, Divider, Grid, Box } from '@mui/material';

/**
 * Mirrors the "ADVANCE SUMMARY" block on the printed form, including the
 * two rows the previous version was missing: Total Penalties and Advance Offset.
 */
const Row = ({ label, value, bold, color }) => (
  <>
    <Grid item xs={7}>
      <Typography variant="body2" sx={bold ? { fontWeight: 'bold' } : undefined}>
        {label}
      </Typography>
    </Grid>
    <Grid item xs={5}>
      <Typography
        variant="body2"
        align="right"
        sx={{ ...(bold ? { fontWeight: 'bold' } : {}), ...(color ? { color } : {}) }}
      >
        {value}
      </Typography>
    </Grid>
  </>
);

const AdvanceSummary = ({ advanceSummary, formatCurrency }) => {
  const a = advanceSummary || {};

  return (
    <Paper sx={{ p: 2, height: '100%' }} data-testid="advance-summary">
      <Typography variant="h6" gutterBottom color="primary">
        ADVANCE SUMMARY
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={1}>
          <Row label="Advance b/f" value={formatCurrency(a.advanceBF)} />
          <Row label="Advances Given" value={formatCurrency(a.advancesGiven)} />
          <Row label="Int on Adv Given" value={formatCurrency(a.intOnAdvGiven)} />
          <Row label="Total Penalties" value={formatCurrency(a.totalPenalties)} />
          <Row label="Total" value={formatCurrency(a.total)} bold />
          <Row label="Less Advance Paid" value={formatCurrency(a.lessAdvancePaid)} />
          <Row label="Advance Offset" value={formatCurrency(a.advanceOffset)} />
          <Row
            label="Adv c/f"
            value={formatCurrency(a.advCF)}
            bold
            color="error.main"
          />
        </Grid>
      </Box>
    </Paper>
  );
};

export default AdvanceSummary;